// src/components/QuizModal.jsx
import React from 'react';
import InteractiveQuiz from './InteractiveQuiz';

export default function QuizModal({ open, onClose, question, choices, correctAnswer }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
        >
          &times;
        </button>
        <h2 className="text-2xl font-semibold text-indigo-700 mb-4">Lesson Quiz</h2>
        <InteractiveQuiz
          question={question}
          choices={choices}
          correctAnswer={correctAnswer}
        />
      </div>
    </div>
  );
}
